export { Skull as default } from './Skull';
